<div class="main-container">
  <mat-card appearance="outlined">
    <mat-card-title>Company Information</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Company Name</strong></th>
          <td>{{ settingsModel.name }}</td>
        </tr>
        <tr>
          <th><strong>Package Name</strong></th>
          <td>{{ settingsModel.packageName }}</td>
        </tr>
        <tr>
          <th><strong>HIPAA Enabled</strong></th>
          <td>{{ settingsModel.hippaEnabled | yesno }}</td>
        </tr>
        <tr>
          <th><strong>Package Expiration Date</strong></th>
          <td>{{ settingsModel.packageExpirationDate | dateTime: 'M/dd/yyyy' }}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
</div>
<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Company Settings</mat-card-title>
      <mat-card-content>
        <table class="table mt-4">
          <tbody>
          <tr>
            <th><strong>Time Zone</strong></th>
            <td>
              <app-mat-autocomplete [formControl]="getFormControl('timezoneIANA')" name="timezoneIANA"
                                    [hideLabel]="true"
                                    (valueChanged)="onZoneChanged($event)"
                                    [hintLabel]="'Your Current time is ' + currentTime"
                                    [autoCompleteValues]="zonesControlTimeZones" [submitted]="submitted"
              ></app-mat-autocomplete>
            </td>
          </tr>
          <tr>
            <th><strong>Agent Ring time considered as missed</strong></th>
            <td>
              <app-mat-number-input [formControl]="getFormControl('reportingMaxRingTime')" name="reportingMaxRingTime"
                                    [hideLabel]="true"
                                    [submitted]="submitted"
              ></app-mat-number-input>
            </td>
          </tr>
          <tr>
            <th style="border: none"><strong>Max IP Whitelist Records</strong></th>
            <td style="border: none">{{ settingsModel.maxFirewallRecords }}</td>
          </tr>
          </tbody>
        </table>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" *ngIf="settingsModel.hippaEnabled">
      <mat-card-title>HIPAA Fax Settings</mat-card-title>
      <mat-card-content fxLayout="column" fxLayoutGap="20px">
        <app-mat-checkbox-input [formControl]="getFormControl('faxHipaEnabled')"
                                label="Enable Fax HIPAA Cover Page" name="faxHipaEnabled"
                                [submitted]="submitted"></app-mat-checkbox-input>
        <app-upload-fax fxFlex #fileInput1 name="upload-fax1" id="upload-fax1"
                        *ngIf="getFormControl('faxHipaEnabled').value"
                        [allowImages]="false"
                        [previewPdf]="previewPdf"
                        (validationError)="onFileValidationError($event)"
                        (valueChanged)="onFileChanged1($event)"
        ></app-upload-fax>

      </mat-card-content>
    </mat-card>

    <mat-card appearance="outlined" *ngIf="hasHhaModule">
      <mat-card-title>HHAeXchange Settings</mat-card-title>
      <mat-card-content>
        <div formGroupName="hhaAuth">
          <app-mat-text-input formControlName="apiUrl" label="API Url"
                              name="hhaAuthApiUrl" [submitted]="submitted"></app-mat-text-input>
          <app-mat-text-input formControlName="appName" label="App Name"
                              name="hhaAuthAppName" [submitted]="submitted"></app-mat-text-input>
          <app-mat-text-input formControlName="appKey" label="App Key"
                                  name="hhaAuthAppKey" [submitted]="submitted"></app-mat-text-input>
          <app-mat-text-input formControlName="appSecret" label="App Secret"
                                  name="hhaAuthSecret" [submitted]="submitted"></app-mat-text-input>
          <app-mat-checkbox-input formControlName="useLocalSearch" label="Search By Contacts In Customer Portal"
                                  name="useLocalSearch" [submitted]="submitted"></app-mat-checkbox-input>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
</div>
<div class="has-edit-action-bar">&nbsp;</div>
<div class="edit-action-bar" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
  <button mat-raised-button type="submit" color="primary" matTooltip="Save changes"
          (click)="onSubmit()" [disabled]="submitted"
          [promiseBtn]="buttonSubmitPromise">Save
  </button>
</div>
